import React from 'react';
import { Link } from 'react-router-dom';

function Register(): JSX.Element {
  return (
    <div className="card">
      <h2>📋 Register for the Camping Trip</h2>
      <p>Registering helps us plan how much food to bring and how big the site needs to be.</p>
      <p>
        You'll answer a few questions and create a login at the same time. An admin
        will text you once your account is approved — then come back and sign in to see the
        exact campground, site number, and directions.
      </p>
      <Link to="/signup">
        <button>Register Now</button>
      </Link>
    </div>
  );
}

export default Register;
